import { render, staticRenderFns } from "./serial-lottery.vue?vue&type=template&id=7a687348&scoped=true"
import script from "./serial-lottery.vue?vue&type=script&lang=js"
export * from "./serial-lottery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a687348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a687348')) {
      api.createRecord('7a687348', component.options)
    } else {
      api.reload('7a687348', component.options)
    }
    module.hot.accept("./serial-lottery.vue?vue&type=template&id=7a687348&scoped=true", function () {
      api.rerender('7a687348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/components/form-b/serial-lottery.vue"
export default component.exports